import { Component, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { ToastService } from 'src/app/services/toast.service';
import { Subscription } from 'rxjs';
import { FeedbackListComponent } from 'src/app/components/feedbacks/feedback-list.component';
import { FeedbackCategory, IFeedback } from 'src/app/models/feedback.model';
import { FeedbackResponse, FeedbacksResponse } from 'src/app/models/response.model';
import { ISortOption } from 'src/app/models/sort.model';
import { FeedbackService } from 'src/app/services/feedback.service';
import { HelperService } from 'src/app/services/helper.service';

@Component({
  selector: 'app-feedback',
  templateUrl: './feedback.component.html',
  styleUrls: ['./feedback.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class FeedbackComponent {
  @ViewChild(FeedbackListComponent) feedbackListComponent!: FeedbackListComponent;
  private subscription = new Subscription();

  public FeedbackCategory = FeedbackCategory;

  public feedback = {} as IFeedback;

  constructor(
    private helperService: HelperService,
    private feedbackSerivce: FeedbackService,
    private toastService: ToastService,
  ) {}

  public onBadgeClick(category: FeedbackCategory) {
    this.feedback.category = category;
  }

  public handleCreateFeedback(): void {
    if (!this.feedback.category) {
      return this.toastService.error('Please select one of the options!');
    }
    if (!this.feedback.text.trim()) {
      return this.toastService.error('Text field is empty!');
    }
    this.createNewFeedback();
  }

  private createNewFeedback(): void {
    this.subscription.add(
      this.feedbackSerivce.createFeedback(this.feedback).subscribe({
        next: (res: FeedbackResponse) => {
          this.feedbackListComponent.getAllFeedbacks();
          this.feedback = {} as IFeedback;
          this.toastService.success('Feedback was successfully added');
        },
        error: () => {
          this.toastService.error('Failed to create a new feedback');
        },
      }),
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
